module.exports = __webpack_public_path__ + "img/材料力学6_10.4a3b6067.jpg";